"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectOptionsSubject = exports.getFormatMessage = exports.getFormattedMessage = void 0;
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var getFormattedMessage = function (messageKey) {
    var messageId = messageKey || '';
    if (messageKey && messageKey !== '') {
        return react_1.default.createElement(react_intl_1.FormattedMessage, { id: messageId });
    }
    return '';
};
exports.getFormattedMessage = getFormattedMessage;
var getFormatMessage = function (messageKey, intl) {
    var tmpTexts = react_intl_1.defineMessages({
        dynamicLabel: {
            id: messageKey || 'notfound',
            defaultMessage: '',
        },
    });
    var message = intl.formatMessage(tmpTexts.dynamicLabel);
    return message;
};
exports.getFormatMessage = getFormatMessage;
exports.selectOptionsSubject = [
    {
        messageKey: 'form.type.subject.option.order',
    },
    {
        messageKey: 'form.type.subject.option.datasecurity',
    },
    {
        messageKey: 'form.type.subject.option.web',
    },
    {
        messageKey: 'form.type.subject.option.account',
    },
    {
        messageKey: 'form.type.subject.option.pesonalData',
    },
    {
        messageKey: 'form.type.subject.option.bonus',
    },
    {
        messageKey: 'form.type.subject.option.product',
    },
    {
        messageKey: 'form.type.subject.option.complaint.textileshoes',
    },
    {
        messageKey: 'form.type.subject.option.complaint.hometextile',
    },
    {
        messageKey: 'form.type.subject.option.complaint.furtherassortments',
    },
    {
        messageKey: 'form.type.subject.option.complaint.returnsprocessing',
    },
];
var CustomMessages = react_intl_1.defineMessages({
    errorEmailApi: {
        id: 'errorApi',
        defaultMessage: '',
    },
    errorEmailApiRecipientNotFound: {
        id: 'errorEmailRecipientNotFound',
        defaultMessage: '',
    },
});
exports.default = CustomMessages;
//# sourceMappingURL=messages.js.map